import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Modal as StackFlowModal } from '@stackflow/plugin-basic-ui';
import { useFlow } from '@stackflow/react';
import { ReactNode } from 'react';

interface Props {
    title?: string;
    children?: ReactNode;
    deny?: string;
    confirm?: string;
    onDeny?: () => void,
    onConfirm?: () => void,
    confirmDisabled?: boolean;
    denyDisabled?: boolean;
    disableOutside?: boolean;
    confirmId?: string;
    confirmAttributes?: Record<string, string | number | undefined>;
}

function AppModal({
    title, children, deny, confirm, onDeny, onConfirm, confirmDisabled, denyDisabled, disableOutside,
    confirmId, confirmAttributes,
}:Props) {
    const { pop } = useFlow();
    return (
        <StackFlowModal borderRadius='var(--radius-lg)'
            className='modal-wrapper'
            dimBackgroundColor='rgba(0, 0, 0, 0.5)'
            onOutsideClick={disableOutside ? (e) => {
                e.preventDefault();
                e.stopPropagation();
            } : undefined} >
            <Contents fullWidth spacing={4} align='center'>
                {title && (
                    <Text align='center' size='display' fontWeight='bold' css={css`white-space: pre-wrap;`}>{title}</Text>
                )}
                {children}
            </Contents>
            {(deny || confirm) && (
                <Footer spacing={2}>
                    {deny && (
                        <Button fullWidth
                            variant='tone'
                            size='large'
                            onClick={onDeny || pop}
                            disabled={denyDisabled} >
                            {deny}
                        </Button>
                    )}
                    {confirm && (
                        <Button fullWidth
                            id={confirmId}
                            {...confirmAttributes}
                            size='large'
                            onClick={onConfirm}
                            disabled={confirmDisabled} >
                            {confirm}
                        </Button>
                    )}
                </Footer>
            )}

        </StackFlowModal>
    );
}

const Contents = styled(Column)`
    padding: var(--spacing-6)  var(--spacing-10) var(--spacing-4);
`;

const Footer = styled(Row)`
    padding: 0 var(--spacing-4) var(--spacing-4);
`;

export default AppModal;
